import React, { useState } from "react";
import { Link } from "react-router-dom";
import BusinessCard from "./components/cards/BusinessCard";

export default function ForJobSeekers() {
  const testimonials = [
    {
      id: 1,
      image: "/asset/ForJobSeekers/1.png",
      quote: "I had to switch jobs quickly due to personal circumstances, and Hiree made the process incredibly easy. I got multiple offers within 24 hours! Hiree helped me connect with a great employer, and I've been working here for 3 months now. Highly recommend it!",
      author: "Aaron M."
    },
    {
      id: 2,
      image: "/asset/ForJobSeekers/2.png",
      quote: "Hiree's platform is incredibly user-friendly. I found my dream job at a local café within days. The application process was smooth, and the team was very supportive throughout.",
      author: "Sarah L."
    },
    {
      id: 3,
      image: "/asset/ForJobSeekers/3.png",
      quote: "As someone new to the hospitality industry, Hiree made it easy to find entry-level positions. The detailed job descriptions and direct communication with employers were incredibly helpful.",
      author: "Michael R."
    }
  ];

  const [currentTestimonial, setCurrentTestimonial] = useState(0);

  const nextTestimonial = () => {
    setCurrentTestimonial((prev) => (prev + 1) % testimonials.length);
  };

  const prevTestimonial = () => {
    setCurrentTestimonial((prev) => (prev - 1 + testimonials.length) % testimonials.length);
  };

  return (
    <div className="min-h-screen bg-white">
      {/* Hero Section with Search Bar */}
      <div className="relative">
        {/* Hero Section */}
        <section className="relative bg-[#FFF5EB] pt-16 pb-40 overflow-hidden">
          {/* Background pattern */}
          <div className="absolute inset-0">
            <img
              src="/asset/ForJobSeekers/hero.png"
              alt="Background Pattern"
              className="absolute inset-0 w-full h-full object-cover opacity-70"
            />
            <div className="absolute inset-0 bg-[#FFF5EB]/60"></div>
          </div>

          <div className="max-w-6xl mx-auto px-6 relative">
            <div className="flex flex-col md:flex-row items-start gap-4">
              {/* Left Content */}
              <div className="md:w-[52%] relative z-10">
                {/* Title Section */}
                <div className="mb-16">
                  <div className="text-left">
                    <h1 className="text-[48px] leading-[1.2] font-bold text-[#1A237E] mb-4 w-full">
                      Find Work Fast.
                    </h1>
                    <div className="w-full">
                      <h1 className="text-[48px] leading-[1.2] font-bold text-[#1A237E] mb-4">
                        Anytime, Anywhere!
                      </h1>
                      <div className="relative h-3 w-[85%]">
                        <img
                          src="/asset/ForJobSeekers/yellowLines.png"
                          alt="Underline"
                          className="absolute top-0 left-0 w-full"
                        />
                      </div>
                    </div>
                  </div>
                </div>

                {/* Description Text */}
                <p className="text-gray-700 mb-20 text-left text-xl mt-20">
                  Looking for a job in hospitality, retail, or service industries? Hiree makes it easy to find reliable and flexible job opportunities near you.
                </p>

                {/* Action Button */}
                <div className="mb-16 text-left">
                  <button className="px-10 py-4 bg-[#FF8C00] text-white rounded-xl hover:bg-[#FF8C00]/90 text-lg font-medium">
                    Start Applying Now
                  </button>
                </div>

                {/* Stats Section */}
                <div className="flex gap-16">
                  <div>
                    <div className="text-3xl font-bold text-[#FF8C00]">60<span className="text-2xl">+</span></div>
                    <div className="text-sm text-gray-600 mt-1">Jobs/week</div>
                  </div>
                  <div>
                    <div className="text-3xl font-bold text-[#FF8C00]">250<span className="text-2xl">+</span></div>
                    <div className="text-sm text-gray-600 mt-1">Businesses</div>
                  </div>
                  <div>
                    <div className="text-3xl font-bold text-[#FF8C00]">$150k<span className="text-2xl">+</span></div>
                    <div className="text-sm text-gray-600 mt-1">Earned by job seekers</div>
                  </div>
                </div>
              </div>

              {/* Right Content */}
              <div className="md:w-[48%] relative h-[600px]">
                {/* Teacher image container */}
                <div className="absolute inset-0 flex items-center justify-center">
                  <div className="relative w-[95%] rounded-3xl overflow-hidden bg-white shadow-xl border-2 border-gray-100">
                    <img
                      src="/asset/ForJobSeekers/teaching.png"
                      alt="Teacher"
                      className="w-full h-auto"
                    />
                    {/* Orange accent */}
                    <div className="absolute bottom-0 right-0 w-[60%] h-2 bg-[#FF8C00]"></div>
                    <div className="absolute bottom-0 right-0 w-2 h-[60%] bg-[#FF8C00]"></div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </section>

        {/* Search Section - Overlapping Component */}
        <div className="absolute left-0 right-0 bottom-0 transform translate-y-1/2 z-20">
          <div className="max-w-6xl mx-auto px-6">
            <div className="bg-white rounded-xl shadow-md p-6">
              <h2 className="text-lg font-semibold mb-5 text-center">Search for jobs nearby</h2>
              <div className="flex gap-4">
                <div className="flex-1 relative">
                  <div className="absolute left-3 top-1/2 transform -translate-y-1/2">
                    <svg xmlns="http://www.w3.org/2000/svg" className="w-5 h-5 text-gray-400" viewBox="0 0 20 20" fill="currentColor">
                      <path fillRule="evenodd" d="M8 4a4 4 0 100 8 4 4 0 000-8zM2 8a6 6 0 1110.89 3.476l4.817 4.817a1 1 0 01-1.414 1.414l-4.816-4.816A6 6 0 012 8z" clipRule="evenodd" />
                    </svg>
                  </div>
                  <input
                    type="text"
                    placeholder="Find jobs"
                    className="w-full pl-10 pr-4 py-3 border border-gray-200 rounded-lg focus:outline-none focus:border-[#FF8C00] text-base"
                  />
                </div>
                <div className="flex-1 relative">
                  <div className="absolute left-3 top-1/2 transform -translate-y-1/2">
                    <svg xmlns="http://www.w3.org/2000/svg" className="w-5 h-5 text-gray-400" viewBox="0 0 20 20" fill="currentColor">
                      <path fillRule="evenodd" d="M5.05 4.05a7 7 0 119.9 9.9L10 18.9l-4.95-4.95a7 7 0 010-9.9zM10 11a2 2 0 100-4 2 2 0 000 4z" clipRule="evenodd" />
                    </svg>
                  </div>
                  <input
                    type="text"
                    placeholder="Locations"
                    className="w-full pl-10 pr-4 py-3 border border-gray-200 rounded-lg focus:outline-none focus:border-[#FF8C00] text-base"
                  />
                </div>
                <button className="px-8 py-3 bg-[#FF8C00] text-white rounded-lg hover:bg-[#FF8C00]/90 font-medium text-base whitespace-nowrap">
                  Search
                </button>
                <button className="px-6 py-3 bg-[#4285F4] text-white rounded-lg hover:bg-[#4285F4]/90 font-medium flex items-center gap-2 text-base whitespace-nowrap">
                  <img src="/asset/ForJobSeekers/map-svgrepo-com.svg" alt="Map" className="w-5 h-5" />
                  Map View
                </button>
              </div>
            </div>
          </div>
        </div>
      </div>

      {/* Job Listings */}
      <section className="pt-24 px-6">
        <div className="max-w-6xl mx-auto">
          <h2 className="text-xl font-semibold mb-6">Here are some job openings near you!</h2>
          <div className="grid md:grid-cols-3 gap-6 mb-8">
            {/* Job Card 1 */}
            <div className="border-2 border-[#FF8C00] rounded-2xl p-6 hover:shadow-xl transition-shadow bg-[#FFF5EB] relative">
              <div className="font-bold text-xl absolute top-4 left-4 text-gray-900">
                Realtor $90000/Year
              </div>
              <img
                src="/asset/ForJobSeekers/handshake.png"
                alt="LIC Lux realty"
                className="w-full h-56 object-contain rounded-xl mb-4 mt-8"
              />
              <div className="flex justify-between items-center mb-3">
                <h3 className="font-bold text-2xl">LIC Lux realty</h3>
                <div className="text-sm text-gray-500">3 hours ago</div>
              </div>
              <p className="text-gray-600 text-base">
                Server waiting position available for high-end restaurant. Must have high-performance hospitality work experience and a keen sense of style.
              </p>
            </div>

            {/* Job Card 2 */}
            <div className="border-2 border-[#FF8C00] rounded-2xl p-6 hover:shadow-xl transition-shadow bg-[#FFF5EB] relative">
              <div className="font-bold text-xl absolute top-4 left-4 text-gray-900">
                Bristas $16-25/h
              </div>
              <img
                src="/asset/ForJobSeekers/cafeAtCorner.jpg"
                alt="Cafe at corner"
                className="w-full h-56 object-contain rounded-xl mb-4 mt-8"
              />
              <div className="flex justify-between items-center mb-3">
                <h3 className="font-bold text-2xl">Cafe at corner</h3>
                <div className="text-sm text-gray-500">5 days ago</div>
              </div>
              <p className="text-gray-600 text-base">
                Full-time barista position with competitive pay. Must have experience with specialty & non-specialty coffee brewing and good sales skills.
              </p>
            </div>

            {/* Job Card 3 */}
            <div className="border-2 border-[#FF8C00] rounded-2xl p-6 hover:shadow-xl transition-shadow bg-[#FFF5EB] relative">
              <div className="font-bold text-xl absolute top-4 left-4 text-gray-900">
                Stock organizer $17/h
              </div>
              <img
                src="/asset/ForJobSeekers/streetDeli.jpg"
                alt="Street Deli"
                className="w-full h-56 object-contain rounded-xl mb-4 mt-8"
              />
              <div className="flex justify-between items-center mb-3">
                <h3 className="font-bold text-2xl">Street Deli</h3>
                <div className="text-sm text-gray-500">1 day ago</div>
              </div>
              <p className="text-gray-600 text-base">
                Looking to hire a chef with high-level experience in deli cuisine. Must have strong culinary expertise and be able to maintain smooth operations behind the grill.
              </p>
            </div>
          </div>
          <div className="text-center">
            <button className="px-8 py-3 bg-[#FF8C00] text-white rounded-xl hover:bg-[#FF8C00]/90 text-lg">
              See all jobs near you →
            </button>
          </div>
        </div>
      </section>

      {/* Testimonial Section */}
      <section className="bg-[#FFF5EB] py-16 px-6 relative overflow-hidden">
        <div className="max-w-6xl mx-auto">
          <div className="flex flex-col md:flex-row items-center gap-8 relative">
            <div className="md:w-1/2 relative">
              <img
                src={testimonials[currentTestimonial].image}
                alt="Testimonial"
                className="w-full h-auto rounded-lg"
              />
            </div>
            <div className="md:w-1/2 relative">
              {/* Navigation Buttons */}
              <button 
                onClick={prevTestimonial}
                className="absolute left-[-30px] top-1/2 -translate-y-1/2 w-10 h-10 rounded-full bg-white shadow-md flex items-center justify-center hover:bg-gray-50 transition-colors"
              >
                <img src="/asset/ForJobSeekers/arrow-left.PNG" alt="Previous" className="w-6 h-6" />
              </button>
              <button 
                onClick={nextTestimonial}
                className="absolute right-[-30px] top-1/2 -translate-y-1/2 w-10 h-10 rounded-full bg-white shadow-md flex items-center justify-center hover:bg-gray-50 transition-colors"
              >
                <img src="/asset/ForJobSeekers/arrow-right.png" alt="Next" className="w-6 h-6" />
              </button>

              {/* Testimonial Content */}
              <div className="relative min-h-[200px]">
                <blockquote className="text-gray-700 italic mb-4 text-lg transition-opacity duration-500">
                  {testimonials[currentTestimonial].quote}
                </blockquote>
                <p className="font-bold text-xl transition-opacity duration-500">
                  - {testimonials[currentTestimonial].author}
                </p>
              </div>
            </div>

            {/* Dots Indicator */}
            <div className="absolute bottom-[-20px] left-1/2 transform -translate-x-1/2 flex gap-2">
              {testimonials.map((_, index) => (
                <button
                  key={index}
                  onClick={() => setCurrentTestimonial(index)}
                  className={`w-2 h-2 rounded-full transition-colors ${
                    index === currentTestimonial ? 'bg-[#FF8C00]' : 'bg-gray-300'
                  }`}
                />
              ))}
            </div>
          </div>
        </div>
      </section>

      {/* Map Section */}
      <section className="py-16 px-6">
        <div className="max-w-6xl mx-auto">
          <div className="flex flex-col md:flex-row items-start gap-12">
            {/* Phone Images - Left Side */}
            <div className="md:w-1/2 relative">
              <div className="absolute inset-0 bg-[#FFF5EB] rounded-3xl"></div>
              <div className="relative h-[400px] flex items-center justify-center">
                {/* First Phone - Left */}
                <div className="absolute left-[100px] top-[40%] -translate-y-1/2 w-[35%] z-10">
                  <img
                    src="/asset/ForJobSeekers/h.png"
                    alt="Map Interface"
                    className="w-full h-auto"
                  />
                </div>
                {/* Second Phone - Right */}
                <div className="absolute right-[100px] top-[60%] -translate-y-1/2 w-[35%]">
                  <img
                    src="/asset/ForJobSeekers/j.png"
                    alt="Job Details"
                    className="w-full h-auto"
                  />
                </div>
              </div>
            </div>

            {/* Text Content - Right Side */}
            <div className="md:w-1/2">
              <h2 className="text-[32px] font-bold mb-4 text-[#2B3674]">
                Find Jobs Close to Home – Work Where You Want
              </h2>
              <p className="text-gray-600 mb-8">
                Instantly discover jobs near you and apply with ease. Stay local, save time, and start working faster.
              </p>
              <ul className="space-y-4 mb-8">
                <li className="flex items-center gap-2">
                  <span className="text-[#FF8C00]">•</span>
                  <span><strong className="text-[#2B3674]">Local Opportunities</strong> - Find jobs in your area with real-time updates.</span>
                </li>
                <li className="flex items-center gap-2">
                  <span className="text-[#FF8C00]">•</span>
                  <span><strong className="text-[#2B3674]">Instant Apply</strong> - Apply for nearby jobs with just one tap.</span>
                </li>
                <li className="flex items-center gap-2">
                  <span className="text-[#FF8C00]">•</span>
                  <span><strong className="text-[#2B3674]">Flexible Work</strong> - Choose part-time, full-time, or shift-based jobs that fit your schedule.</span>
                </li>
                <li className="flex items-center gap-2">
                  <span className="text-[#FF8C00]">•</span>
                  <span><strong className="text-[#2B3674]">Verified Employers</strong> - Work with trusted businesses near you.</span>
                </li>
              </ul>
              <button className="px-8 py-3 bg-[#FF8C00] text-white rounded-xl hover:bg-[#FF8C00]/90 text-lg font-medium">
                Find a Job Now
              </button>
            </div>
          </div>
        </div>
      </section>

      {/* Business Listings */}
      <section className="py-16 px-6 bg-gray-50">
        <div className="max-w-6xl mx-auto">
          <div className="flex justify-between items-center mb-8">
            <h2 className="text-2xl font-bold">Here are some business near you</h2>
            <a href="#" className="text-[#FF8C00] hover:underline">See all businesses</a>
          </div>
          <div className="grid grid-cols-1 sm:grid-cols-2 md:grid-cols-3 lg:grid-cols-5 gap-4 mb-8">
            {[
              { 
                name: "Cafe", 
                logo: "/asset/ForJobSeekers/Frame 1321314691.png",
                description: "Coffee and pastries",
                address: "12 Main Street, Flushing",
                businessId: "cafe-1"
              },
              { 
                name: "Flying pigs", 
                logo: "/asset/ForJobSeekers/Frame 1321314692.png",
                description: "BBQ and Grill",
                address: "25 Park Avenue, Queens",
                businessId: "flying-pigs"
              },
              { 
                name: "Noodle bar", 
                logo: "/asset/ForJobSeekers/Frame 1321314693.png",
                description: "Asian cuisine",
                address: "5 Center Road, Brooklyn",
                businessId: "noodle-bar-1"
              },
              { 
                name: "Jolie's", 
                logo: "/asset/ForJobSeekers/Frame 1321314694.png",
                description: "French cuisine",
                address: "18 5th Avenue, Manhattan",
                businessId: "jolies"
              },
              { 
                name: "Prince dessert", 
                logo: "/asset/ForJobSeekers/Frame 1321314695.png",
                description: "Cakes and pastries",
                address: "42 West Street, Queens",
                businessId: "prince-dessert"
              },
              { 
                name: "Noodle bar", 
                logo: "/asset/ForJobSeekers/Frame 1321314696.png",
                description: "Ramen and dumplings",
                address: "78 East Road, Manhattan",
                businessId: "noodle-bar-2"
              },
              { 
                name: "Coffee House", 
                logo: "/asset/ForJobSeekers/Frame 1321314691.png",
                description: "Specialty coffee",
                address: "123 Main Street, Manhattan",
                businessId: "coffee-house"
              },
              { 
                name: "Dante bar", 
                logo: "/asset/ForJobSeekers/Frame 1321314698.png",
                description: "Cocktails and tapas",
                address: "56 Night Avenue, Manhattan",
                businessId: "dante-bar"
              },
              { 
                name: "Dessert bar", 
                logo: "/asset/ForJobSeekers/Frame 1321314695.png",
                description: "Sweets and coffee",
                address: "23 Main street, Flushing",
                businessId: "dessert-bar"
              },
              { 
                name: "Lic Lux Realty", 
                logo: "/asset/ForJobSeekers/Frame 1321314694.png",
                description: "Real estate agency",
                address: "100 Business Plaza, Long Island City",
                businessId: "lic-lux-realty"
              },
            ].map((business, index) => (
              <BusinessCard 
                key={index}
                name={business.name}
                logo={business.logo}
                description={business.description}
                address={business.address}
                businessId={business.businessId}
              />
            ))}
          </div>
          <div className="text-center">
            <button className="px-6 py-3 bg-white text-[#FF8C00] border border-[#FF8C00] rounded-lg hover:bg-gray-50">
              Load more
            </button>
          </div>
        </div>
      </section>
    </div>
  );
}
